// extracted by mini-css-extract-plugin
module.exports = {"navBar":"FreeNavbar_navBar__1xhZX","wrapper":"FreeNavbar_wrapper__Im-fh"};